"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSource = exports.ConfigLoaderStatus = void 0;
/**
 * Enumerate the kinds of results we can get from a configuration loading source.
 */
var ConfigLoaderStatus;
(function (ConfigLoaderStatus) {
    ConfigLoaderStatus[ConfigLoaderStatus["FAILED"] = 0] = "FAILED";
    ConfigLoaderStatus[ConfigLoaderStatus["DID_NOT_PRODUCE"] = 1] = "DID_NOT_PRODUCE";
    ConfigLoaderStatus[ConfigLoaderStatus["COMPLETED"] = 2] = "COMPLETED";
})(ConfigLoaderStatus = exports.ConfigLoaderStatus || (exports.ConfigLoaderStatus = {}));
var ConfigSource;
(function (ConfigSource) {
    ConfigSource[ConfigSource["CONFIG_STORE"] = 0] = "CONFIG_STORE";
    ConfigSource[ConfigSource["FETCH"] = 1] = "FETCH";
    ConfigSource[ConfigSource["NONE"] = 2] = "NONE";
})(ConfigSource = exports.ConfigSource || (exports.ConfigSource = {}));
//# sourceMappingURL=config-loader.js.map